export default __webpack_public_path__ + "static/media/Resa-18.6add0bce.jpg";